import { axiosInstanceV2 } from "@src/shared/api";
import { PRODUCT_REVIEW_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export interface ISendProductReviewRequestDto {
  overall_satisfaction: number;
  useful_features: string[];
  interface_clarity: number;
  desired_improvements: string[];
  speed_rating: number;
  has_blockers: boolean;
  blockers_text: string | null;
  recommend_score: number;
  comment: string | null;
}

export const sendProductReview = (data: ISendProductReviewRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  return axiosInstanceV2.post(
    PRODUCT_REVIEW_API_URL.createProductReview,
    data,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );
};
